import Vue from 'vue'
// 引入触屏指令
import touch from './touch'

// 指令集合
let directives = [...touch]

export default () => {
  directives.forEach((item) => {
    Vue.use(item)
  })
}
